import React from 'react'
import { Button } from '@mantine/core'

/**
 * Renders an apply button for a job posting.
 * @param {string} color The background color of the button.
 * @param {string} href The URL where the user can apply to the job.
 * @param {object} props Any valid Mantine Button prop.
 * @returns {JSX.Element}
 */
function ApplyButton ({
  color,
  href,
  ...props
}) {
  return (
    <Button
      {...props}
      size={props.size ?? 'xl'}
      color={color}
      component='a'
      href={href}
      target='_blank'
    >
      APPLY NOW
    </Button>
  )
}

export default React.memo(ApplyButton)
